<div>
  <div class="header">
    <br />
    <div class="titles">
      <h2>
        {{
          'project.files.title'
            | transloco: { quantity: this.totalDocs ? this.totalDocs : 0 }
        }}
      </h2>
    </div>

    <lead-ui-search
      [type]="'Buscar análise'"
      [list]="originalCurrentProject"
      (searchMode)="searchMode = $event"
      (searchValue)="getFiles(1, $event)"
    ></lead-ui-search>
  </div>
  <div class="sub-header" *ngIf="files$ | async as file">
    <div class="content" *ngIf="file.docs; else loadError">
      <div *ngIf="currentProjects.length > 0">
        <table>
          <thead>
            <tr>
              <th>
                {{ 'project.files.headers.file' | transloco | uppercase }}
              </th>
              <th>
                {{ 'project.files.headers.origin' | transloco | uppercase }}
              </th>
              <th>{{ 'project.files.headers.id' | transloco | uppercase }}</th>
              <th>
                {{ 'project.files.headers.date' | transloco | uppercase }}
              </th>
              <th>
                {{ 'project.files.headers.stats' | transloco | uppercase }}
              </th>
              <th class="actions">
                {{ 'project.files.headers.actions' | transloco | uppercase }}
              </th>
            </tr>
          </thead>
          <tbody
            *ngFor="
              let items of currentProjects
                | paginate
                  : {
                      id: 'projects',
                      itemsPerPage: 10,
                      currentPage: currentPage,
                      totalItems: this.totalDocs
                    }
            "
          >
            <td>
              <span class="text">{{ items.name }}</span>
            </td>
            <td>
              <span class="text">{{ items.origin }}</span>
            </td>
            <td>
              <span class="text">{{ items.requestId }}</span>
            </td>
            <td>
              <span class="text">{{ formatDate(items.createdAt) }}</span>
            </td>
            <td
              class="status"
              [ngSwitch]="
                statusService.getStatus(items.countsResponse, items.status)
              "
            >
              <div>
                <button
                  *ngSwitchCase="status.DONE"
                  class="stats ready"
                  mat-flat-button
                >
                  {{ 'project.files.buttons.showAnalysis' | transloco }}
                </button>
                <button
                  *ngSwitchCase="status.EMPTY"
                  class="stats empty"
                  mat-flat-button
                >
                  {{ 'project.files.errors.customFilterInvalid' | transloco }}
                </button>
                <button
                  *ngSwitchCase="status.PENDING"
                  class="stats process"
                  mat-flat-button
                  color="primary"
                  (click)="openProcessModal()"
                >
                  {{ 'project.files.buttons.pending' | transloco }}
                </button>
                <button
                  [matTooltip]="
                    apiStatus[items.status] !== items.status
                      ? ''
                      : ('project.files.errors.customFilterInvalid' | transloco)
                  "
                  *ngSwitchCase="status.ERROR"
                  class="stats error"
                  mat-flat-button
                  (click)="goToAnalyze(items)"
                >
                  {{ 'project.files.buttons.error_counts' | transloco }}
                </button>
              </div>
            </td>
            <td
              class="actions">
              <div>
                <button
                  mat-icon-button
                  class="action close"
                  *ngIf="getStatus[apiStatus[items.status]] !== status.PENDING"
                >
                <hero-icon
                  (click)="removeFile(items.id)"
                  class="icon"
                  name="trash"
                ></hero-icon>
                </button>
                <button
                mat-icon-button
                class="action"
                *ngIf="
                  getStatus[apiStatus[items.status]] == status.DONE
                "
                >
                  <hero-icon
                    class="icon"
                    name="chevron-right"
                    (click)="
                      router.navigate([
                        getCategoryRoute[getCategoryByValue[items.origin]],
                        items.id
                      ])
                    "
                  ></hero-icon>
                </button>
              </div>
            </td>
          </tbody>
        </table>

        <lead-ui-paginator
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChange)="getFiles($event)"
        ></lead-ui-paginator>
      </div>
      <div *ngIf="currentProjects.length === 0">
        <img src="assets/images/not_have.svg" />
      </div>
    </div>
    <ng-template #loadError>
      <div class="loadError">
        <img src="assets/images/load_error.svg" />
        <h3>{{ 'project.error' | transloco }}</h3>
        <button mat-button class="reload" (click)="refresh()">
          {{ 'project.reload' | transloco | uppercase }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
